const alphaNumericNormalizer = (value) => {
    if (!value) return value;
    const alphaNumeric = new RegExp(/[^0-9a-zA-Z]*/g);
    return value.replace(alphaNumeric, '');
};

export default alphaNumericNormalizer;
